module.exports = __webpack_public_path__ + "static/media/icon-refrigeration.eab0e2f9.svg";